/**
 * Provide a centralized class for triggering loading element. Can keep track of
 * multiple loading events, to ensure the element stays on the screen until all
 * AJAX events are truly finished in the rare event multiple ones occur at once.
 */
export default () => {
  class Packback_Loading {
    constructor() {
      this._loadingEvents = new Map();
      this._$loadingElement = $('.loading-indicator');
    }

    /**
     * Register a loading event as ongoing. Either the given name will be
     * registered with a count of 1, or the count will be increased by 1 if
     * already registered.
     *
     * Pass true as the second parameter to deem the event unique. Unique events
     * will not have their count increased if already registired. This is useful
     * if the same starting event may be called multiple times before a single
     * ending event finally occurs.
     */
    addEvent(name, unique) {
      if (!this._loadingEvents.has(name)) {
        this._loadingEvents.set(name, 1);
      } else if (!unique) {
        const newCount = this._loadingEvents.get(name) + 1;
        this._loadingEvents.set(name, newCount);
      }

      this._toggleIndicator();
    }

    endEvent(name) {
      const currentCount = this._loadingEvents.get(name);

      if (typeof currentCount === 'undefined') {
        return;
      }

      if (currentCount > 1) {
        this._loadingEvents.set(name, currentCount - 1);
      } else {
        this._loadingEvents.delete(name);
      }

      this._toggleIndicator();
    }

    _toggleIndicator() {
      this._$loadingElement.attr('data-loading', this._loadingEvents.size ? 'true' : 'false');
    }
  }

  if (typeof window.packbackLoading === 'undefined') {
    window.packbackLoading = new Packback_Loading();
  }
};
